import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import sqTranslations from './locales/sq.json';
import deTranslations from './locales/de.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      sq: {
        translation: sqTranslations
      },
      de: {
        translation: deTranslations
      }
    },
    lng: 'de', // Force German as default language
    fallbackLng: 'de', // Fallback to German instead of English
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

// Force German language on initialization
if (typeof window !== 'undefined') {
  i18n.changeLanguage('de');
  localStorage.setItem('i18nextLng', 'de');
}

export default i18n;
